import { useEffect } from "react"

//import BalanceActions from '../Balance/reducer'

import { App, Spin } from "antd"
import cls from "classname"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Outlet } from "react-router"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"

import TitleSection from "../../Components/TitleSection/TitleSection"
import { defaultInnerPage } from "../../Sagas/StartupSagas"
import { pagesConfig } from "../Layout/pagesConfig"
import UserActions from "../User/reducer"
import Sidebar from "./components/Sidebar"

import "../PersonalSettings/styles.less"
import "./styles.less"

const pages = [
  "enrollment",
  "integrations",
  "pricing",
  "business_health",
  "users",
  "auto-refund",
  "business",
  "receipts"
]

const getIsSpinnerDisabled = (pathname, disabledPaths) => {
  return disabledPaths.some((path) => pathname.includes(path))
}

const BusinessSettingsPage = ({
  isAdmin,
  userBusinessAccountId,
  businessAccountFetching,
  ...props
}) => {
  const navigate = useNavigate()
  const { notification } = App.useApp()
  const { pathname, search } = useLocation()
  const [searchParams, setSearchParams] = useSearchParams()
  const hashLegacy = pathname.split("/").slice(2).join("/")
  const disableParentSpinner = getIsSpinnerDisabled(pathname, [
    "/business_settings/enrollment",
    "/business_settings/integrations"
  ])

  const pageData = pagesConfig[pathname] || {}

  const businessAccountIdFromSearch = searchParams.get("business_account_id")

  const businessAccountId = isAdmin ? businessAccountIdFromSearch : userBusinessAccountId

  useEffect(() => {
    document.title = "Business Settings - Chargeback"
  }, [])

  useEffect(() => {
    if (!pages.some((page) => pathname.includes(page))) {
      navigate(`/business_settings/enrollment${search}`)
    }
  }, [pathname])

  useEffect(() => {
    if (businessAccountId) {
      props.getBusinessAccount(businessAccountId)
    } else {
      navigate(defaultInnerPage)
      notification.error({
        message: "Business account not found"
      })
    }
  }, [businessAccountId])

  return (
    <div className={cls("settings-page", hashLegacy)}>
      <Sidebar />
      <div className={cls("content", hashLegacy, isAdmin && "admin")}>
        {!isAdmin && pageData.title && (
          <TitleSection
            title={pageData.title}
            description={pageData.description}
            icon={pageData.icon}
            buttonText={pageData.buttonText}
            videoUrl={pageData.videoUrl}
          />
        )}
        <div className="height-auto">
          <Spin spinning={!disableParentSpinner && businessAccountFetching} style={{ padding: 32 }}>
            <Outlet />
          </Spin>
        </div>
      </div>
    </div>
  )
}

BusinessSettingsPage.defaultProps = {}

BusinessSettingsPage.propTypes = {
  fetching: PropTypes.bool,
  isMobile: PropTypes.bool,
  theme: PropTypes.string
}

const mapStateToProps = (state) => ({
  isAdmin: state.auth.isAdmin,
  userBusinessAccountId: state.auth.userInfo.current_business_account_id,
  ba_role: state.auth.userInfo?.ba_role?.id,
  //balanceEnabled: state.auth.userInfo?.['balance_feature'],
  businessAccountFetching: state.user.businessAccountFetching,
  businessAccount: state.user.businessAccount,
  businessAccounts: state.user.businessAccounts,

  saveResult: state.user.saveResult,

  isMobile: state.nav.isMobile,
  theme: state.nav.theme
})

const mapDispatchToProps = (dispatch) => ({
  getBusinessAccount: (businessAccountId) =>
    dispatch(UserActions.getBusinessAccountRequest(businessAccountId)),
  getBusinessAccounts: () => dispatch(UserActions.getBusinessAccountsRequest()),
  userSaveResultReset: () => dispatch(UserActions.userSaveResultReset())
  //getBalance: () => dispatch(BalanceActions.getBalanceRequest()),
})

export default connect(mapStateToProps, mapDispatchToProps)(BusinessSettingsPage)
